import { useMutation } from '@apollo/client';
import { VIEW_FRONT_SMALL_DOG_FENCING } from '../../graphql/user-mutations';

export default function useMutateViewSmallDogFencing() {
    const [viewSmallDogFencing] = useMutation(VIEW_FRONT_SMALL_DOG_FENCING);
    return { viewSmallDogFencing };
}
